let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3kHns"), load("3JzPO"), load("4gtMV"), load("1kb22"), load("fwFM0")]).then(() => parcelRequire('eKYmP'));